<div class="cover">
<iframe class="content" [src]="fileUrl |videoEncrypt:assestBaseUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen ></iframe>
</div>